
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/showcase/[entityId]/embed",
      function () {
        return require("private-next-pages/showcase/[entityId]/embed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/showcase/[entityId]/embed"])
      });
    }
  